import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { OwnerAccount } from "../model/profile/indiviualPropertyOwnerProfie";
import { Observable } from "rxjs";
import { HotelMotelData } from "../model/profile/individualBedAccount";
import { PropertyAccountProfile } from "../model/profile/propertyAccountProfile";
import { HttpResponseDto } from "../model/common/httpResponseDto";
import { ChangePassword } from "../model/profile/changePassword";

@Injectable({
    providedIn: 'root'
  })
  export class ProfileService {
    [x: string]: any;
    private baseUrl = `${environment.apiUrl}`;

    constructor(private http: HttpClient,private readonly router: Router) {}
    httpOptions = {
       headers: new HttpHeaders({
         'Content-Type':  'application/json',
          'Access-Control-Allow-Origin': '*',
     'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
       })
     };

     getIndividualPropertyOwner(accountId: string): Observable<OwnerAccount> {
        return this.http.get<OwnerAccount>(`${this.baseUrl}/profile/individualPropertyOwner/${accountId}`,  this.httpOptions);
      }

      getIndividualBedAccount(accountId: string):  Observable<HotelMotelData> {
        return this.http.get<HotelMotelData>(`${this.baseUrl}/profile/hotelMotelProfile/${accountId}`,  this.httpOptions);
      }

      getPropertyMgmtCo(accountId: string):  Observable<PropertyAccountProfile> {
        return this.http.get<PropertyAccountProfile>(`${this.baseUrl}/profile/propertyMgmtCo/${accountId}`,  this.httpOptions);
      }

      changePassword(model: ChangePassword): Observable<HttpResponseDto> {
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/profile/externalUser/changePassword`, model, this.httpOptions);
      }

      updatePropertyMgmtCo(model: any): Observable<HttpResponseDto> {
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/profile/propertyMgmtCo/update`, model, this.httpOptions);
      }

      updatePropertyMgmtReporting(model: any): Observable<HttpResponseDto> {
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/profile/propertyMgmtCo/reporting/update`, model, this.httpOptions);
      }

      updateHotelMotel(model: any): Observable<HttpResponseDto> {
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/profile/hotelMotelProfile/update`, model, this.httpOptions);
      }

      updateIndividualPropertyOwner(model: any): Observable<HttpResponseDto> {
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/profile/individualPropertyOwner/update`, model, this.httpOptions);
      }
  }